import React from 'react';
import propTypes from 'prop-types';
import { Form, Input as SemanticInput } from 'semantic-ui-react';

// TODO: errorMessage={errorMessage}
// TODO: error handling for required, type
// TODO: Successfully saved message import { LoadingSpinner } from 'icons'
// TODO: loading, label, type: propTypes.oneOf(['text','date','number']),

const Input = ({
  autofocus,
  containerStyle,
  errorMessage,
  inputContainer,
  name,
  onChange,
  placeholder,
  icon,
  isError,
  value,
  ...rest
  }) => {

  return(
    <div className={inputContainer}>
      <Form.Field className={isError ? 'ui error input' : 'ui input'}>
        <SemanticInput
          {...rest}
          autoFocus={autofocus}
          icon={icon}
          name={name}
          onChange={onChange}
          placeholder={placeholder}
          value={value}
        />
      </Form.Field>
      {isError ? <p className='error-message'>{errorMessage}</p> : ''}
    </div>
  )
};

Input.propTypes = {
  autofocus: propTypes.bool,
  containerStyle: propTypes.string,
  errorMessage: propTypes.string,
  icon: propTypes.string,
  isError: propTypes.bool,
  inputContainer: propTypes.string,
  name: propTypes.string.isRequired,
  placeholder: propTypes.string,
  value: propTypes.string,
};
Input.defaultProps = {
  autofocus: false,
  containerStyle: 'class',
  errorMessage: 'Sorry, try again',
  icon: '',
  isError: false,
  inputContainer: 'input__container',
  placeholder: '',
  value: '',
};

export default Input;



// WEBPACK FOOTER //
// ./src/Adapters/UI/Input/Input.js